import env from '../env'

export const ENV_NAME = env('REACT_APP_ENVIRONMENT', 'SIT')

export const SITE_API = env(
    'REACT_APP_RECAPTCHA_SITE_TOKEN',
    '6Lf95KAUAAAAADYYlzvosPco79Z8_Cda6z5eHfCW'
)

export const CREDIT_CARD_PAYMENT =
    env('REACT_APP_CREDIT_CARD_PAYMENT', '0') === '1'

export const GTM_ID = env('REACT_APP_GTM_ID', 'GTM-5SC835K')

export const GTM_AUTH = env('REACT_APP_GTM_AUTH', '')

export const GTM_PREVIEW = env('REACT_APP_GTM_PREVIEW', '')

export const PME_HOME_PAGE = env(
    'REACT_APP_PME_HOME_PAGE',
    'https://pedidos.alelo.com.br/'
)
